export default __webpack_public_path__ + "static/media/8.3d330e9d.jpg";